export default "__VITE_ASSET__86888b3f__"